import React from 'react';

const ImageModal = ({ imageUrl, onClose }) => {
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
      onClick={onClose} // Close modal when clicking outside the image
    >
      <div className="relative max-w-3xl max-h-full overflow-auto p-4" onClick={(e) => e.stopPropagation()}> {/* Prevent modal closing when clicking on image */}
        <button
          className="absolute top-2 right-2 text-white text-2xl font-bold bg-gray-800 rounded-full w-8 h-8 flex items-center justify-center"
          onClick={onClose}
        >
          &times;
        </button>
        <img src={imageUrl} alt="Amplified Product" className="max-w-full max-h-full object-contain" />
      </div>
    </div>
  );
};

export default ImageModal;